export const downloadBlob = (blob, filename) => {
  let url = window.URL.createObjectURL(blob);
  let hiddenElement = document.createElement('a');
  hiddenElement.style = 'display: none';
  hiddenElement.href = url;
  hiddenElement.download = filename;
  hiddenElement.click();
  window.URL.revokeObjectURL(url);
  hiddenElement.remove();
};
